import type { ScatterShapeProps } from 'recharts';

import { EstimationScatterDot } from './EstimationScatterDot';
import { resolveScatterDotColors } from './EstimationScatterShape';

const INNER_RADIUS = 5.5;
const GAP = 3;
const STROKE_WIDTH = 3;
const HALO_RADIUS = 14;

type Props = ScatterShapeProps;

export const EstimationScatterActiveShape: React.FC<Props> = (props) => {
  const { cx, cy } = props;

  if (cx == null || cy == null) {
    return null;
  }

  const { fill, stroke } = resolveScatterDotColors(props);

  return (
    <g>
      <circle cx={cx} cy={cy} r={HALO_RADIUS} fill={fill} opacity={0.24} />
      <EstimationScatterDot
        cx={cx}
        cy={cy}
        fill={fill}
        stroke={stroke}
        innerRadius={INNER_RADIUS}
        gap={GAP}
        strokeWidth={STROKE_WIDTH}
      />
    </g>
  );
};
